
export function view(_corpus, _search, _dispatch) {
    throw (new Error("NOT IMPLEMENTED"));
}

